import React from 'react';
import { Route, Navigate, useLocation } from 'react-router-dom';

export const PrivateRoute = ({ children, location }) => {
    
    return localStorage.getItem('token') ?
        children :
        <Navigate to={{ pathname: '/login', state: { from: location } }} />;
    
}